import {array} from 'json-bouncer'
import {FeedbackLoop} from '../../Data/FeedbackLoop'
import {decodeHttpResponse, HttpError} from '../../Data/Http'
import {update} from '../../Data/ObjectHelper'
import {Result} from '../../Data/Result'
import {bpsUserDecoder} from '../../Entities/BpsUser'
import * as PrismaRequestFilteringState
    from './Model/PrismaRequestFilteringState'
import * as PrismaRequestFilterInput from './Model/PrismaRequestFilterInput'
import {PrismaRequestFilteringAction} from './PrismaRequestFilteringActions'
import {
    PrismaRequestFilteringFeedback,
    PrismaRequestFilteringRequestIdentifier
} from './PrismaRequestFilteringFeedback'
import * as BpsUserResource from '../../Request/BpsUserResource'

type PrismaRequestFilteringLoop =
    FeedbackLoop<PrismaRequestFilteringState.M, PrismaRequestFilteringFeedback>

export function reducer(
    state: PrismaRequestFilteringState.M,
    action: PrismaRequestFilteringAction,
): PrismaRequestFilteringLoop {
    switch (action.type) {
        case 'FilterSelectChanged':
            return {
                state: update(
                    {
                        selectedFilter: action.value,
                        addFilterInput:
                            PrismaRequestFilterInput.fromFilterType(
                                action.value,
                            ),
                    },
                    state,
                ),
                feedback: [],
            }
        case 'BpsUserSearchChanged':
            if (state.addFilterInput !== null &&
                state.addFilterInput.type === 'BpsUserFilterInput'
            ) {
                return {
                    state: update(
                        {
                            addFilterInput: update(
                                {bpsUserSearch: action.value},
                                state.addFilterInput,
                            ),
                        },
                        state,
                    ),
                    feedback: [],
                }
            }
            return {state, feedback: []}
        case 'FetchBpsUserSuggestions': {
            if (state.addFilterInput !== null &&
                state.addFilterInput.type === 'BpsUserFilterInput'
            ) {
                return {
                    state,
                    feedback: [{
                        type: 'SendRequest',
                        identifier: {
                            type: 'BpsUserSuggestionList'
                        },
                        httpRequest:
                            BpsUserResource.listSuggestions(
                                state.addFilterInput.bpsUserSearch
                            ),
                    }]
                }
            }
            return {state, feedback: []}
        }
        case 'BpsUserSuggestionListResponse': {
            if (state.addFilterInput !== null &&
                state.addFilterInput.type === 'BpsUserFilterInput'
            ) {
                const bpsUsers =
                    decodeHttpResponse(
                        array(bpsUserDecoder()),
                        action.result,
                    )
                return {
                    state: update(
                        {
                            addFilterInput: update(
                                {
                                    type: 'BpsUserFilterInput',
                                    bpsUserSuggestions:
                                        bpsUsers.type === 'Ok'
                                            ? bpsUsers.value
                                            : [],
                                },
                                state.addFilterInput,
                            ),
                        },
                        state,
                    ),
                    feedback: [],
                }
            }
            return {state, feedback: []}
        }
        case 'ClearBpsUserSuggestions':
            if (state.addFilterInput !== null &&
                state.addFilterInput.type === 'BpsUserFilterInput'
            ) {
                return {
                    state: update(
                        {
                            addFilterInput: update(
                                {bpsUserSuggestions: []},
                                state.addFilterInput,
                            ),
                        },
                        state,
                    ),
                    feedback: [],
                }
            }
            return {state, feedback: []}
        case 'AddFilter': {
            const newState = PrismaRequestFilteringState.submit(state)
            return {
                state: newState,
                feedback: [{
                    type: 'FiltersChanged',
                    filters: newState.activeFilters,
                }],
            }
        }
        case 'ResetFilters': {
            const newState = PrismaRequestFilteringState.clearFilters(state)
            return {
                state: newState,
                feedback: [{
                    type: 'FiltersChanged',
                    filters: newState.activeFilters,
                }],
            }
        }
        case 'RemoveFilter': {
            const newState =
                PrismaRequestFilteringState.removeFilter(action.filterType, state)
            return {
                state: newState,
                feedback: [{
                    type: 'FiltersChanged',
                    filters: newState.activeFilters,
                }],
            }
        }
        case 'InputChanged':
            return {
                state: PrismaRequestFilteringState.reduceFilterInputChanged(
                    action.subAction,
                    state,
                ),
                feedback: [],
            }
        case 'PopoverToggle':
            return {
                state: update({popoverOpen: action.open}, state),
                feedback: [],
            }
    }
}

export function httpResponseAction(
    identifier: PrismaRequestFilteringRequestIdentifier,
    result: Result<HttpError, string>,
): PrismaRequestFilteringAction {
    switch (identifier.type) {
        case 'BpsUserSuggestionList':
            return {
                type: 'BpsUserSuggestionListResponse',
                result
            }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/PrismaRequestFilteringReducer.ts